import React from 'react'
import { Modal as AntModal, Button, Space } from 'antd'
import styles from './Modal.scss'
import { CloseOutlined } from '@ant-design/icons'

const allowedSizes = ['sm', 'md', 'lg', 'xl'] as const
type ModalSize = (typeof allowedSizes)[number]
const [SIZE_SM] = allowedSizes

interface ModalProps {
  isOpen?: boolean
  size?: ModalSize
  onClose: () => void
  header?: React.ReactNode
  children: React.ReactNode
  className?: string
  headerClassName?: string
  style?: React.CSSProperties
}

interface ModalAction {
  color?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'link'
  label: string | React.ReactNode
  isDisplayed?: boolean
  [key: string]: any
}

interface ModalActionsProps {
  actions: ModalAction[]
}

export const Modal: React.FC<ModalProps> = ({
  isOpen = false,
  size = SIZE_SM,
  onClose,
  header,
  children,
  className,
  headerClassName,
  style = {},
}) => (
  <AntModal
    open={isOpen}
    onCancel={onClose}
    footer={null}
    width={500}
    className={styles.modal}
    title={header ? (
      <div className={styles.header}>
        <div className={styles.title}>{header}</div>
      </div>
    ) : null}
  >
    <div style={style} className={styles.body}>
      {children}
    </div>
  </AntModal>
)

export const ModalActions: React.FC<ModalActionsProps> = ({ actions }) => (
  <Space className={styles.actions}>
    {actions
      .filter(({ isDisplayed = true }) => isDisplayed)
      .map((action) => {
        const { color = 'primary', label, isDisplayed, ...rest } = action
        return (
          <Button {...rest} type='primary' className={styles.action} key={label}>
            {label}
          </Button>
        )
      })}
  </Space>
)
